import { createContext, useContext } from 'react';
import DiseasePrevalenceStore from './DiseasePrevalenceStore';
import ChronicPrevalenceStore from './ChronicPrevalenceStore';
import EmployerGroupStore from './EmployerGroupStore';
import LoginPageStore from './LoginPageStore';
import MemberSummaryStore from './MemberSummaryStore';
import NavigationStore from './NavigationStore';
import { RecommendedTabStore } from './RecommendedTabStore';
import PathStore from './PathStore';
import { RisingRiskStore } from './RisingRiskStore';
import SummaryCardsStore from './SummaryCards';
import TabStore from './TabStore';
import EpisodeOfCareStore from './EpisodeOfCareStore';
import MembersStore from './MembersStore';
import CustomReportsStore from './CustomReportsStore';
import CustomDashboardStore from './CustomDashboardStore';
import UserTableStore from './UserTableStore';
import CohortDetailsStore from './CohortDetailsStore';
import CustomQueriesStore from './CustomQueriesStore';
import CareQualityStore from './CareQualityStore';
import WasteCalculatorStore from './WasteCalculatorStore';
import FileUploadStore from './FileUploadStore';
import ContractAiqStore from './ContractAiqStore';
import { QuaterlyReportStore } from './QuaterlyReportStore';
import ComplianceAssuranceStore from './ComplianceAssuranceStore';
import CareNavigatorStore from './CareNavigatorStore';
import UserDetailsStore from './UserDetailsStore';
import { FiscalControlStore } from './FiscalControlStore';

class RootStore {
  navigationStore: NavigationStore;
  tabStore: TabStore;
  summaryCardsStore: SummaryCardsStore;
  memberSummaryStore: MemberSummaryStore;
  loginPageStore: LoginPageStore;
  employerGroupStore: EmployerGroupStore;
  risingRiskStore: RisingRiskStore;
  diseasePrevalenceStore: DiseasePrevalenceStore;
  chronicPrevalenceStore: ChronicPrevalenceStore;
  episodeOfCareStore: EpisodeOfCareStore;
  recommendedTabStore: RecommendedTabStore;
  pathStore: PathStore;
  membersStore: MembersStore;
  customReportsStore: CustomReportsStore;
  customDashboardStore: CustomDashboardStore;
  customQueriesStore: CustomQueriesStore;
  userTableStore: UserTableStore;
  cohortDetailsStore: CohortDetailsStore;
  careQualityStore: CareQualityStore;
  wasteCalculatorStore: WasteCalculatorStore;
  fileUploadStore: FileUploadStore;
  contractAiqStore: ContractAiqStore;
  quaterlyReportStore: QuaterlyReportStore;
  complianceAssuranceStore: ComplianceAssuranceStore;
  careNavigatorStore: CareNavigatorStore;
  userDetailsStore: UserDetailsStore;
  fiscalControlStore: FiscalControlStore;
  constructor() {
    this.navigationStore = new NavigationStore();
    this.tabStore = new TabStore();
    this.summaryCardsStore = new SummaryCardsStore();
    this.memberSummaryStore = new MemberSummaryStore();
    this.loginPageStore = new LoginPageStore();
    this.employerGroupStore = new EmployerGroupStore();
    this.risingRiskStore = new RisingRiskStore();
    this.diseasePrevalenceStore = new DiseasePrevalenceStore();
    this.chronicPrevalenceStore = new ChronicPrevalenceStore();
    this.episodeOfCareStore = new EpisodeOfCareStore();
    this.recommendedTabStore = new RecommendedTabStore();
    this.pathStore = new PathStore();
    this.membersStore = new MembersStore();
    this.customReportsStore = new CustomReportsStore();
    this.customDashboardStore = new CustomDashboardStore();
    this.userTableStore = new UserTableStore();
    this.cohortDetailsStore = new CohortDetailsStore();
    this.customQueriesStore = new CustomQueriesStore();
    this.careQualityStore = new CareQualityStore();
    this.wasteCalculatorStore = new WasteCalculatorStore();
    this.fileUploadStore = new FileUploadStore();
    this.contractAiqStore = new ContractAiqStore();
    this.quaterlyReportStore = new QuaterlyReportStore();
    this.complianceAssuranceStore = new ComplianceAssuranceStore();
    this.careNavigatorStore = new CareNavigatorStore();
    this.userDetailsStore = new UserDetailsStore();
    this.fiscalControlStore = new FiscalControlStore();
  }
}

export const RootStoreContext = createContext(new RootStore());

export const useStores = () => {
  return useContext(RootStoreContext);
};

export default RootStore;
